import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
  box-sizing: border-box;

  & > img,
  input {
    //TODO: картинки не дизейблятся, надо переработать
    pointer-events: ${(props) => (props.isDisabled ? 'none' : '')};
    cursor: ${(props) => (props.isDisabled ? 'default' : '')};
  }

  & > div > div > div > img {
    cursor: ${(props) => (props.isDisabled ? 'default' : '')};
  }
`;

export const SearchWrapper = styled.div<{
  isActive: boolean;
  isDisabled?: boolean;
}>`
  box-sizing: border-box;
  display: flex;
  max-height: 40px;
  border-radius: 8px;
  border: ${(props) =>
    props.isActive ? '1px solid #2d67d8' : '1px solid #ced5de'};
  box-shadow: ${(props) =>
    props.isActive ? '0px 0px 0px 4px #e0eeff' : 'none'};
  :hover {
    border: ${(props) =>
      props.isActive
        ? '1px solid #2d67d8'
        : props.isDisabled
        ? '1px solid #ced5de'
        : '1px solid #9da6b4'};
  }
`;
